const { types, referenceTypes, uiTypes } = require("../utils/types");
const { validatorTypes } = require("../utils/validatorTypes");


const obj = {
    tableName: "newletters",
    read: true,
    create: true,
    edit: true,
    delete: true,
    comments: false, //for enabiling comments on view and edit
    references: [],
    columns: [
        {
            name: "id",
            type: types.UUID,
            allowNull: false,
            defaultValue: types.UUIDV4,
            primaryKey: true,
            validation: [validatorTypes.uuid, validatorTypes.optional],
            ui: {
                // added for ui
                type: uiTypes.TEXT, //UI Types
                validation: [], //UI Validation
                list: true,
                read: true,
                create: false,
                edit: false,
            },
        },
        {
            name: "email",
            type: types.STRING,
            validation: [validatorTypes.email, validatorTypes.optional],
            ui: {
                // added for ui
                type: uiTypes.TEXT, //UI Types
                validation: [], //UI Validation
                list: true,
                read: true,
                create: true,
                edit: true,
            },
        },
        {
            name: "spam",
            type: types.BOOLEAN,
            isArray: false,
            defaultValue: false,
            validation: [validatorTypes.bool, validatorTypes.optional],
            ui: {
                // added for ui
                type: uiTypes.SWITCH, //UI Types
                validation: [], //UI Validation
                list: true,
                read: true,
                create: true,
                edit: true,
            },
        },
        {
            name: "createdAt",
            type: types.DATE,
            allowNull: false,
            defaultValue: null,
            ui: {
                // added for ui
                type: uiTypes.DATE, //UI Types
                validation: [], //UI Validation
                list: true,
                read: true,
                create: false,
                edit: false,
            },
        },
        {
            name: "updatedAt",
            type: types.DATE,
            allowNull: false,
            defaultValue: null,
            ui: {
                // added for ui
                type: uiTypes.DATE, //UI Types
                validation: [], //UI Validation
                list: true,
                read: true,
                create: false,
                edit: false,
            },
        },
        {
            name: "deletedAt",
            type: types.DATE,
            allowNull: true,
            defaultValue: null,
            read: false,
            ui: {
                // added for ui
                type: uiTypes.TEXT, //UI Types
                validation: [], //UI Validation
                list: false,
                read: false,
                create: false,
                edit: false,
            },
        },
    ],
    listFunc: (req, res, db) => {},
    readFunc: (req, res, db) => {},
    createFunc: (req, res, db) => {},
    editFunc: (req, res, db) => {},
    deleteFunc: (req, res, db) => {},
};
module.exports = obj;
